const contextKey = {};

export { contextKey };
